import { StatisticCollectionDTO } from '@/api/event/dto/statistics/StatisticCollectionDTO'
import { StatisticCollection } from '@/model/StatisticCollection'
import { StatisticFactory } from './StatisticFactory'

export class StatisticCollectionFactory {
  static fromDTO(dto: StatisticCollectionDTO): StatisticCollection {
    return new StatisticCollection(dto.statistics.map(StatisticFactory.fromDTO), dto.totalStatistics)
  }
}
